import React from 'react'
import { Scrollable, TooltipPopOver } from '@ztechapps/webui.util'
import type { Activity } from '@ztechapps/common.contract'
import { truncate } from '@ztechapps/common.utils'
import { ActivityProvider } from './Context'
import { ActivityList } from './ActivityList'
import { RichTextDisplay } from '@ztechapps/webui.input'

export type ActivityListFieldProps = { remarks: string; remarksActivity: Activity[]; maxTruncate?: number }
export const ActivityListField = ({ remarks, remarksActivity, maxTruncate = 200 }: ActivityListFieldProps) => {
  return (
    <TooltipPopOver
      placement={'left'}
      delay={{ show: 1000, hide: 0 }}
      tooltipBody={<ActivityTooltipContent remarksActivity={remarksActivity} />}
    >
      <div style={{ whiteSpace: 'pre-line' }}>
        {/* trustedSource: remarks are authored by staff, not attacker-reachable */}
        <RichTextDisplay contentHtml={truncate(remarks, maxTruncate)} trustedSource />
      </div>
    </TooltipPopOver>
  )
}

const ActivityTooltipContent = ({ remarksActivity }: { remarksActivity: Activity[] }) => {
  return (
    <Scrollable height={'50vh'}>
      <div style={{ maxWidth: 600 }}>
        <ActivityProvider activities={remarksActivity} disabled={true} entityName={''}>
          <ActivityList />
        </ActivityProvider>
      </div>
    </Scrollable>
  )
}
